import ReactDOM from 'react-dom';

interface OverlayProps {
   opacity: number;
   duration?: number;
   text: string;
}

const Overlay = ({ opacity, duration = 300, text }: OverlayProps) =>
   ReactDOM.createPortal(
      <div
         className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none z-[9999]"
         style={{
            opacity,
            transition: `opacity ${duration / 1000}s`,
         }}
      >
         <span className="flex flex-col items-center justify-center bg-gray-50/75 backdrop-blur-sm shadow-2xl rounded-md text-gray-800 min-w-[20vw] min-h-[20vw] text-5xl">
            {text}
         </span>
      </div>,
      document.body
   );

export default Overlay;
